import {useMemo} from "react";

import {CONTENT_TYPES, GENERAL_TYPE} from "data/products";
import {useRouteParams, DEFAULT_ROUTE_PATTERNS} from "hooks/useRouteParams";

export function useContentTypeFromParams() {
  const params = useRouteParams(DEFAULT_ROUTE_PATTERNS);
  return useMemo(() => {
    const contentTypeParam = params?.contentType ?? null;
    const contentType = CONTENT_TYPES.find((type) => type.value === contentTypeParam);

    return contentType || GENERAL_TYPE;
  }, [params]);
}
